import { useState } from "react";
import styles from "./Tab.module.scss";

export const Tab = ({ options, onClick }) => {
  const [activeTab, setActiveTab] = useState(0);
  return (
    <div className={styles.tabContainer}>
      {options.map((tab, index) => (
        <span
          className={`${activeTab === index ? styles.activeTab : ""} ${styles.tabStyling}`}
          onClick={() => {
            if (activeTab === index) return;
            setActiveTab(index);
            onClick(index);
          }}
          key={tab.value}>
          {tab.name}
        </span>
      ))}
    </div>
  );
};
